import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ReportTable } from '../report-table/report-table';
import { ReportRunState } from '../report-run-state';
import { ReportSeriesChart } from "../report-series-chart/report-series-chart";
import { ReportXYChart } from "../report-xy-chart/report-xy-chart";
import { ReportAISummary } from "../report-ai-summary/report-ai-summary";
import {
  ReportDisplayItem,
  isSeriesChartDisplayItem,
  isTableDisplayItem,
  isTextDisplayItem,
  isAISummaryDisplayItem,
  AISummaryDisplay,
  SeriesChartDisplay,
  TableDisplay,
  TextDisplay,
  XYChartDisplay,
  isXYChartDisplayItem,
} from "../../../models/runnable_report";

@Component({
  selector: 'risr-features-reports-report-result',
  imports: [
    ReportTable,
    ReportSeriesChart,
    ReportXYChart,
    ReportAISummary
],
  templateUrl: './report-result.html',
  styleUrl: './report-result.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportResult {

  private readonly reportRunState = inject(ReportRunState);

  protected readonly reportDisplay = this.reportRunState.getDisplay();
  protected readonly securityContextPreserved = computed(() => this.reportRunState.securityContextPreserved());

  isTableDisplayItem(item: ReportDisplayItem): item is TableDisplay {
    return isTableDisplayItem(item);
  }

  isSeriesChartDisplayItem(item: ReportDisplayItem): item is SeriesChartDisplay {
    return isSeriesChartDisplayItem(item);
  }

  isXYChartDisplayItem(item: ReportDisplayItem): item is XYChartDisplay {
    return isXYChartDisplayItem(item);
  }

  isTextDisplayItem(item: ReportDisplayItem): item is TextDisplay {
    return isTextDisplayItem(item);
  }

  isAISummaryDisplayItem(item: ReportDisplayItem): item is AISummaryDisplay {
    return isAISummaryDisplayItem(item);
  }

}
